/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bankid_medium'
export default icon
